import { defineMessages } from 'react-intl';

export default defineMessages({
    cardOption: {
        id: '_.select_payment_method.card_option',
        defaultMessage: 'Card ●●●● {cardLastDigits}'
    },
    bankAccountOption: {
        id: '_.select_payment_method.bank_account_option',
        defaultMessage: 'Account {accountNumber}'
    },
    manualPayment: {
        id: '_.select_payment_method.manual_payment',
        defaultMessage: 'Manual Bank Transfer'
    },
    truelayerRepayment: {
        id: '_.select_payment_method.truelayer_repayment',
        defaultMessage: 'Instant Bank Transfer'
    }
});
